

















































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { Category } from '@/enums/category'

import ProductList from '../components/ProductList.vue'

export default Vue.extend({
  data: () => ({
      orderArray: ['Name (A-Z)', 'Name (Z-A)', 'Price (High - Low)', 'Price (Low - High)'] as string[],
      sortBy: 'Name (A-Z)' as string
  }),
  computed: {
    categories() {
      if (this.loading) {
        return [Category.ALL]
      }

      const unfilteredCategories : String[] = [Category.FEATURED, Category.ALL, Category.INTERIOR, Category.EXTERIOR, Category.PACKAGE]
      const filteredCategories : String[] = []
      const productArray = [this.featuredProducts, this.products, this.interiorProducts, this.exteriorProducts, this.packages]

      for (let i = 0; i < unfilteredCategories.length; ++i) {
        if (productArray[i].length > 0) filteredCategories.push(unfilteredCategories[i])
      }

      return filteredCategories
    },
    isMobile() : boolean {
      const { xs, sm } = this.$vuetify.breakpoint
      return xs || sm
    },
    ...mapGetters({
      categoryFromStore: 'categories/category',
      featuredProducts: 'products/featuredProducts',
      interiorProducts: 'products/interiorProducts',
      exteriorProducts: 'products/exteriorProducts',
      packages: 'products/packages',
      products: 'products/products',
      loading: 'products/loading',
      trim: 'trims/currentTrim',
      currentDealer: 'dealers/currentDealer'
    }),
    numProducts() : any {
      switch(this.categoryFromStore) {
        case Category.FEATURED:
          return this.featuredProducts.length
        case Category.ALL:
          return this.products.length
        case Category.INTERIOR:
          return this.interiorProducts.length
        case Category.EXTERIOR:
          return this.exteriorProducts.length
        case Category.PACKAGE:
          return this.packages.length
      }
      return this.category
    },
    category: {
      get() {
        return this.categoryFromStore
      },
      set(newCategory: Category) {
        this.$store.commit('categories/setCurrentCategory', newCategory)
      }
    }
  },
  watch: {
    trim: function (newTrim) {
      this.$store.dispatch('products/reloadProducts', { trimId: newTrim.id, dealerId: this.currentDealer.id })
    }
  },
  mounted() {
    this.$store.dispatch('products/reloadProducts', { trimId: this.trim.id, dealerId: this.currentDealer.id })
  },
  components: {
    ProductList
  }
})
